import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';
import ModalTypes from '../../../constants/ModalTypes';

export function* updatePointSystemInCurrentBoard(isEnabled) {
  const { boardId } = yield select(selectors.selectPath);

  yield put(
    actions.updatePointSystem(boardId, {
      isEnabled,
    }),
  );

  let pointSystem;
  try {
    ({ item: pointSystem } = yield call(request, api.updatePointSystem, boardId, { isEnabled }));
  } catch (error) {
    yield put(actions.updatePointSystem.failure(boardId, error));
    return;
  }

  yield put(actions.updatePointSystem.success(pointSystem));
}

export function* openPointSystemModalInCurrentBoard() {
  const { boardId } = yield select(selectors.selectPath);
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);

  if (!pointSystem) {
    let createdPointSystem;
    try {
      ({ item: createdPointSystem } = yield call(request, api.updatePointSystem, boardId, {
        isEnabled: false,
      }));
    } catch (error) {
      yield put(actions.updatePointSystem.failure(boardId, error));
      return;
    }

    yield put(actions.updatePointSystem.success(createdPointSystem));
  }

  yield put(actions.openModal(ModalTypes.POINT_SYSTEM));
}

export default {
  updatePointSystemInCurrentBoard,
  openPointSystemModalInCurrentBoard,
};
